import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../app-config';
import { APP_CONFIG } from '../app-config.token';
import { ApiResult } from '../models/ApiResult';
import { BYPASS_ERROR_HANDLER } from '../common/utils/http-context-tokens';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  private http = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  private readonly API_URL = this.config.resourceApiURI + '/home';

  constructor() { }

  redirectTo(): Observable<ApiResult<string>> {
    const url = `${this.API_URL}/redirectTo`;
    const context = new HttpContext().set(BYPASS_ERROR_HANDLER, true);
    return this.http.get<ApiResult<string>>(url, { context });
  }
}
